import React, { useEffect, useState, useRef } from 'react';
import { Grid, Typography, Button, Stepper, Step, StepLabel } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { TEXTOS_LEGALES } from "../../../helper";
import { obtenerPermisosValorAlt } from '../../../../../global/js/funciones';
import { TextoBienestar } from '../../components/BienestarTextoLegal';
import { FirmaBienestar } from '../../components/BienestarFirma';
import { generarPdfConFirmas } from '../pdf/generarPdfConFirmas';
import TareasTerminadas from '../../../../general/TareasTerminadas';
import emma_w from '../../../../../global/imagenes/emma_w.png';
import { Formulario001Steps } from './Formulario001';
import { Formulario002Steps } from './Formulario002';
import { Formulario003Steps } from './Formulario003';
import { Formulario004Steps } from './Formulario004';
import { Formulario005Steps } from './Formulario005';
import { Formulario006Steps } from './Formulario006';
import { Formulario007Steps } from './Formulario007';
import { Formulario008Steps } from './Formulario008';
import { Formulario009Steps } from './Formulario009';
import { FormatoPsicoeducacion008Steps } from './FormularioPsicoeducacion008';
import { FormularioActaArchivoDefinitivoSteps } from './FormularioActaArchivoDefinitivo';
import { FormularioActaArchivoProvisionalSteps } from './FormularioActaArchivoProvisional';
import { FormularioDesistimientoSteps } from './FormularioDesistimientoAtencionVBG';
import { FormularioComunicacionCierreSteps } from './FormularioCierreComunicacionRuta';
import { VALIDACIONES_FASE } from '../schemas/faseSchema';


const formularios_config = {
    F1_001: Formulario001Steps,
    F2_002: Formulario002Steps,
    F2_003: Formulario003Steps,
    F2_004: Formulario004Steps,
    F2_005: Formulario005Steps,
    F3_006: Formulario006Steps,
    F5_007: Formulario007Steps,
    F5_008: Formulario008Steps,
    F6_009: Formulario009Steps,
    T_1: FormularioActaArchivoDefinitivoSteps,
    T_2: FormularioActaArchivoProvisionalSteps,
    T_3: FormularioDesistimientoSteps,
    T_4: FormatoPsicoeducacion008Steps,
    T_5: FormularioComunicacionCierreSteps,
    };

const titulos_formulario_fases = {
    F1_001: 'Atención de la Emergencia',
    F2_002: 'Consentimiento informado para la activación de la RUTA VBG',
    F2_003: 'Consentimiento Informado para la Recepción de Entrevistas de la Ruta VBG',
    F2_004: 'Consentimiento informado para la recepción de entrevista terceros',
    F2_005: 'Entrevistas ruta de atención VBG',
    F3_006: 'Ruta de atención acompañamiento integral pedagógico',
    F5_007: 'Ruta de atención medidas restaurativas de la persona afectada',
    F5_008: 'Ruta de atención socialización medidas restaurativas persona ofensora',
    F6_009: 'Ruta de atención seguimiento a la implementación de la ruta.',
    T_1: 'Acta archivo definitivo',
    T_2: 'Acta de archivo provisional',
    T_3: 'Desistimiento Ruta de atención VBG',
    T_4: 'Psicoeducación',
    T_5: 'Comunicación cierre ruta',
};

const formularios_unica_firma = ['T_1', 'T_2', 'T_5'];

export function FormularioMaestroFases({
    formId,
    state,
    onChange,
    pintarSelect,
    opciones,
    activeStep,
    setActiveStep,
    firmaRefEntrevistado,
    firmaRefResponsable,
    ProteccionDatosComponent,
    texto_proteccion_datos,
    onError,
    solicitud,
    profesionales_opciones = []
    }) {
    const theme = useTheme();
    const stepperVertical = useMediaQuery(theme.breakpoints.down("sm"));
    const [legalData, setLegalData] = useState({
        titulo: "Cargando...",
        descripcion: "",
        aceptacion: ""
    });

    const localFirmaRef = useRef(null);
    const localFirmaRefResponsable = useRef(null);
    const firmaRef = firmaRefEntrevistado || localFirmaRef;
    const firmaRefResponsableLocal = firmaRefResponsable || localFirmaRefResponsable;

    const limpiarFirmaGenerico = (ref) => {
            if (ref && ref.current) {
                ref.current.clear();
            }
        };

    const formSteps = formularios_config[formId] || [];

    const steps = [
        { label: 'Información Legal', type: 'legal' },
        ...formSteps.map(step => ({ ...step, type: 'form' })),
        { label: 'Firma', type: 'firma' }
    ];

    useEffect(() => {
        async function fetchTextoLegal() {
        try {
            const valores = await obtenerPermisosValorAlt([
            { llave: 'principal__codigo', valor: formId },
            { llave: 'secundario__generica', valor: TEXTOS_LEGALES }
            ]);
            const item = valores?.[0]?.secundario;
            setLegalData({
            titulo: item?.nombre || "Información Legal",
            descripcion: item?.descripcion || "No se encontró descripción.",
            aceptacion: item?.valorb || "No se encontró el término legal."
            });
        } catch (err) {
            console.error("Error cargando textos legales:", err);
        }
        }
        fetchTextoLegal();
    }, [formId]);

    const getStepContent = (index) => {
        const step = steps[index];
        switch (step.type) {
        case 'legal':
            return (
            <>
            {(formId !== 'F1_001' && formId !== 'T_4' && formId !== 'T_1'  && formId !== 'T_2' ) && (
                <>
                    <Typography
                        variant="caption"
                        style={{
                            color: '#1976d2',
                            display: 'block',
                            marginBottom: 6,
                            fontWeight: 500
                        }}
                    >
                        👉 Haz clic en el bloque inferior para leer y aceptar el texto legal
                    </Typography>

                    <TextoBienestar 
                        contenido={legalData}
                        onChange={onChange}
                        fieldName="acepta_terminos"
                        aceptado={state?.acepta_terminos?.valor}
                    />
                </>
            )}


            {texto_proteccion_datos && ProteccionDatosComponent && (
                <div style={{ marginTop: 12 }}>
                {ProteccionDatosComponent}
                </div>
            )}
            </>
        );

        case 'form':
            return step.render({
            state,
            onChange,
            pintarSelect,
            opciones,
            solicitud,
            onError,
            profesionalesOpciones: profesionales_opciones
            });

        case 'firma':
            if (formularios_unica_firma.includes(formId)) {
                return (
                    <FirmaBienestar
                        firmaRefEntrevistado={firmaRefResponsableLocal}
                        firmaRefResponsable={firmaRefResponsableLocal}
                        limpiarFirma={limpiarFirmaGenerico}
                        requiereDobleFirma={false}
                        tipoFase={formId}
                        profesionalesOpciones={profesionales_opciones}
                        data={state}
                        onChange={onChange}
                        onError={onError}
                    />
                );
            }
            const esDoble = !formularios_unica_firma.includes(formId);
            return (
                <FirmaBienestar 
                    firmaRefEntrevistado={firmaRef} 
                    firmaRefResponsable={firmaRefResponsableLocal} 
                    limpiarFirma={limpiarFirmaGenerico}
                    requiereDobleFirma={esDoble}
                    tipoFase={formId}
                    profesionalesOpciones={profesionales_opciones}
                    data={state}
                    onChange={onChange}
                    onError={onError}
                />
            );

        default:
            return null;
        }
    };

    return (
        <Grid container direction="column">
            <Grid item xs={12}>
                <Stepper
                    activeStep={activeStep}
                    alternativeLabel={!stepperVertical}
                    orientation={stepperVertical ? "vertical" : "horizontal"}
                    style={{ padding: stepperVertical ? "8px 0 8px 4px" : "8px 0 4px" }}
                >
                    {steps.map((step) => (
                        <Step key={step.label} style={{ padding: stepperVertical ? "2px 0" : 4 }}>
                            <StepLabel
                                StepIconProps={{ style: { fontSize: 20 } }}
                                style={{ marginTop: stepperVertical ? 0 : 2 }}
                            >
                                <Typography
                                    variant="caption"
                                    component="span"
                                    style={{
                                        display: "block",
                                        textAlign: stepperVertical ? "left" : "center",
                                        maxWidth: stepperVertical ? "none" : 120,
                                        margin: stepperVertical ? 0 : "0 auto",
                                        lineHeight: 1.25,
                                        wordBreak: "break-word",
                                    }}
                                >
                                    {step.label}
                                </Typography>
                            </StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Grid>
            <Grid item xs={12}>
                {getStepContent(activeStep)}
            </Grid>
        </Grid>
    );
    }

// ---------------------------------------------

export function FormularioMaestroFasesConAcciones(props) {
    const theme = useTheme();
    const accionesApiladas = useMediaQuery(theme.breakpoints.down("sm"));
    const [activeStep, setActiveStep] = React.useState(0);
    const [cargando, setCargando] = useState(false);
    const firmaRef = useRef(null);
    const firmaRefResponsable = useRef(null);
    const envioEnCursoRef = useRef(false);

    useEffect(() => {
        setActiveStep(0);
    }, [props.formId]);

    const formSteps = formularios_config[props.formId] || [];
    const steps = [
        'Información Legal',
        ...formSteps.map(s => s.label),
        'Firma'
    ];

    const isLastStep = activeStep === steps.length - 1;

    const requiereDobleFirma = (() => {
        return !formularios_unica_firma.includes(props.formId);
    })();

    const obtenerValorCampo = (campo) => {
        const valorCampo = props.state?.[campo];
        if (
            valorCampo &&
            typeof valorCampo === 'object' &&
            Object.prototype.hasOwnProperty.call(valorCampo, 'valor')
        ) {
            return valorCampo.valor;
        }
        return valorCampo;
    };

    const esVacio = (valor) => valor === undefined || valor === null || String(valor).trim() === '';

    const esOpcionSi = (valor) => /^S[ÍI]?$/i.test(String(valor || '').trim());

    const mostrarErrorValidacion = (titulo) => {
        if (props.actualizarMensaje) {
            props.actualizarMensaje({
                titulo,
                tipo: 'warning',
                mostrar: true,
                tiempo: 3500,
            });
        }
    };

    const limpiarErroresCampos = (campos = []) => {
        if (!props.setFieldError) return;
        campos.forEach((campo) => props.setFieldError(campo, ''));
    };

    const marcarErrorCampo = (campo, mensaje) => {
        if (!props.setFieldError) return;
        props.setFieldError(campo, mensaje);
    };

    const validarPasoLegal = () => {
        const muestraTextoLegal = !['F1_001', 'T_4', 'T_1', 'T_2'].includes(props.formId);
        const muestraProteccionDatos = Boolean(props.texto_proteccion_datos && props.ProteccionDatosComponent);

        if (muestraTextoLegal && !obtenerValorCampo('acepta_terminos')) {
            mostrarErrorValidacion('Debes aceptar el texto legal para continuar.');
            return false;
        }

        if (muestraProteccionDatos && !obtenerValorCampo('acepta_proteccion_datos')) {
            mostrarErrorValidacion('Debes aceptar la protección de datos para continuar.');
            return false;
        }

        return true;
    };


    const validarPasoDesdeSchema = (formId, step) => {
        const configPaso = VALIDACIONES_FASE?.[formId]?.[step];
        if (!configPaso) return null;

        const construirErrorItemArray = (reglaArray, index, fieldKey) => {
            const template = reglaArray?.itemErrorKeyTemplate;
            if (!template) return `${reglaArray.key}_${index}_${fieldKey}`;
            return template
                .replace('${index}', String(index))
                .replace('${field}', String(fieldKey));
        };

        const evaluarCondicion = (when = {}) => {
            const key = when?.key;
            if (!key) return true;

            const valor = obtenerValorCampo(key);

            if (Object.prototype.hasOwnProperty.call(when, 'equals')) {
                return String(valor || '').trim().toUpperCase() === String(when.equals || '').trim().toUpperCase();
            }

            if (when.isSi) return esOpcionSi(valor);
            if (when.notSi) return !esOpcionSi(valor);
            if (when.notEmpty) return !esVacio(valor);

            return Boolean(valor);
        };

        const camposAResetear = [
            ...(configPaso.required || []).map((campo) => campo.key),
            ...((configPaso.atLeastOne || []).flatMap((grupo) => {
                const keys = [];
                if (grupo.errorKey) keys.push(grupo.errorKey);
                if (Array.isArray(grupo.errorKeys)) keys.push(...grupo.errorKeys);
                return keys;
            })),
            ...((configPaso.conditionalRequired || []).flatMap((regla) => (regla.fields || []).map((campo) => campo.key))),
            ...((configPaso.arrayRequired || []).map((regla) => regla.errorKey || regla.key))
        ];

        (configPaso.arrayRequired || []).forEach((reglaArray) => {
            const arr = Array.isArray(obtenerValorCampo(reglaArray.key)) ? obtenerValorCampo(reglaArray.key) : [];
            arr.forEach((_, index) => {
                (reglaArray.itemFields || []).forEach((itemField) => {
                    camposAResetear.push(construirErrorItemArray(reglaArray, index, itemField.key));
                });
            });
        });

        limpiarErroresCampos(camposAResetear);

        let tieneError = false;

        (configPaso.required || []).forEach(({ key, label, message }) => {
            if (esVacio(obtenerValorCampo(key))) {
                marcarErrorCampo(key, message || `El campo ${label} es obligatorio.`);
                tieneError = true;
            }
        });

        (configPaso.atLeastOne || []).forEach(({ fields = [], errorKey, errorKeys, message, mode = 'truthy' }) => {
            const cumple = fields.some((field) => {
                const value = obtenerValorCampo(field);
                if (mode === 'si') return esOpcionSi(value);
                if (mode === 'nonEmpty') return !esVacio(value);
                return Boolean(value) || !esVacio(value);
            });

            if (!cumple) {
                const keys = [
                    ...(errorKey ? [errorKey] : []),
                    ...(Array.isArray(errorKeys) ? errorKeys : []),
                ];

                keys.forEach((key) => marcarErrorCampo(key, message || 'Debes seleccionar al menos una opción.'));
                if (keys.length === 0 && fields[0]) {
                    marcarErrorCampo(fields[0], message || 'Debes seleccionar al menos una opción.');
                }
                tieneError = true;
            }
        });

        (configPaso.conditionalRequired || []).forEach((regla) => {
            if (!evaluarCondicion(regla?.when)) return;

            (regla.fields || []).forEach(({ key, label, message }) => {
                if (esVacio(obtenerValorCampo(key))) {
                    marcarErrorCampo(key, message || `El campo ${label} es obligatorio.`);
                    tieneError = true;
                }
            });
        });

        (configPaso.arrayRequired || []).forEach((reglaArray) => {
            const arr = Array.isArray(obtenerValorCampo(reglaArray.key)) ? obtenerValorCampo(reglaArray.key) : [];
            const minItems = Number(reglaArray.minItems || 0);

            if (arr.length < minItems) {
                marcarErrorCampo(
                    reglaArray.errorKey || reglaArray.key,
                    reglaArray.message || `Debes agregar al menos ${minItems} elemento(s).`
                );
                tieneError = true;
            }

            arr.forEach((item, index) => {
                (reglaArray.itemFields || []).forEach((itemField) => {
                    if (esVacio(item?.[itemField.key])) {
                        const errorKey = construirErrorItemArray(reglaArray, index, itemField.key);
                        marcarErrorCampo(errorKey, itemField.message || `El campo ${itemField.label || itemField.key} es obligatorio.`);
                        tieneError = true;
                    }
                });
            });
        });

        if (tieneError) {
            mostrarErrorValidacion(configPaso.message || 'Completa los campos obligatorios para continuar.');
            return false;
        }

        return true;
    };



    // ============================================================================
    // VALIDACIÓN DE FIRMA Y RESPONSABLES
    // ============================================================================

    const validarPasoFirma = () => {
        const esSoloResponsable = formularios_unica_firma.includes(props.formId);

        // Limpiar errores previos
        limpiarErroresCampos(['responsable_atencion', 'tp_responsable']);

        // Validar responsable_atencion y tp_responsable
        const responsableVacio = esVacio(obtenerValorCampo('responsable_atencion'));
        const tpResponsableVacio = esVacio(obtenerValorCampo('tp_responsable'));

        let tieneErrorCampos = false;

        if (responsableVacio) {
            marcarErrorCampo('responsable_atencion', 'Selecciona el responsable de la atención.');
            tieneErrorCampos = true;
        }
        
        if (tpResponsableVacio) {
            marcarErrorCampo('tp_responsable', 'El T.P. del responsable es obligatorio.');
            tieneErrorCampos = true;
        }

        if (tieneErrorCampos) {
            mostrarErrorValidacion('Debes completar los datos del responsable para continuar.');
            return false;
        }

        // Validar firmas
        // Para formularios administrativos, solo valida firma del responsable
        if (esSoloResponsable) {
            const firmaResponsableVacia = firmaRefResponsable?.current?.isEmpty?.() ?? true;
            if (firmaResponsableVacia) {
                mostrarErrorValidacion('El responsable debe firmar el documento.');
                return false;
            }
            return true;
        }

        // Para otros formularios, valida primero firma del entrevistado
        const firmaRef1Vacia = firmaRef?.current?.isEmpty?.() ?? true;
        const firmaRef2Vacia = firmaRefResponsable?.current?.isEmpty?.() ?? true;

        if (firmaRef1Vacia) {
            mostrarErrorValidacion('El interesado / entrevistado debe firmar el documento.');
            return false;
        }

        if (requiereDobleFirma && firmaRef2Vacia) {
            mostrarErrorValidacion('El responsable de la atención debe firmar el documento.');
            return false;
        }

        return true;
    };


    const validarPasoActual = () => {

        if (activeStep === 0) {
            return validarPasoLegal();
        }

        // Paso de firma 
        if (activeStep === steps.length - 1) {
            return validarPasoFirma();
        }

        const resultadoSchema = validarPasoDesdeSchema(props.formId, activeStep);
        if (resultadoSchema !== null) return resultadoSchema;

        return true;
    };

    const handleSiguiente = () => {
        if (!validarPasoActual()) return;
        setActiveStep(prev => prev + 1);
    };

    const handleEnviarConPDF = async () => {
        if (cargando || envioEnCursoRef.current) return false;
        envioEnCursoRef.current = true;
 
        if (!validarPasoFirma()) {
            envioEnCursoRef.current = false;
            return;
        }

        setCargando(true);

        const tituloFase =
            props.tipoFormularioTitulo ||
            titulos_formulario_fases[props.formId] ||
            props.formId;

        // Si es solo administrativo, pasar la referencia del responsable como firmaRef
        const esSoloResponsable = formularios_unica_firma.includes(props.formId);
        const firmaRefParaPDF = esSoloResponsable ? firmaRefResponsable : firmaRef;

        // Estos valores vienen directamente del módulo permitido (secundario)
        const { valora, valorb, valorc, valord, fase } = props;

        try {
            const resultado = await generarPdfConFirmas({
                flujo: "FASE",
                data: props.state,
                tipoFormulario: props.formId,
                tipoFormularioTitulo: tituloFase,
                firmaRef: firmaRefParaPDF,
                firmaRefResponsable,
                requiereDobleFirma,
                bienestarId: props.bienestarId,
                solicitud: props.solicitud,
                valora,
                valorb,
                valorc,
                valord,
                fase,

                onExito: () => {
                    setCargando(false);
                    envioEnCursoRef.current = false;

                    if (props.onSuccess) {
                        props.onSuccess();
                    }

                    if (props.mostrarModal) {
                        props.mostrarModal(false);
                    }
                },

                onError: (error) => {
                    setCargando(false);
                    envioEnCursoRef.current = false;
                    if (props.actualizarMensaje) {
                        props.actualizarMensaje({
                            titulo: error.message || 'Error al generar el documento',
                            tipo: "danger",
                            mostrar: true,
                            tiempo: 4000
                        });
                    }
                },

                mostrarMensaje: (config) => {
                    if (props.actualizarMensaje) {
                        props.actualizarMensaje(config);
                    }
                }
            });

            if (!resultado) {
                setCargando(false);
                envioEnCursoRef.current = false;
                return false;
            }

            return true;
        } catch (error) {
            setCargando(false);
            envioEnCursoRef.current = false;
            if (props.actualizarMensaje) {
                props.actualizarMensaje({
                    titulo: 'Error al procesar el documento',
                    tipo: "danger",
                    mostrar: true,
                    tiempo: 4000
                });
            }
            return false;
        }
    };

    return (
        <>
        {cargando ? (
            <div style={{ minHeight: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <TareasTerminadas
                    mensaje="Generando documento..."
                    marginTop="0"
                    imagen={emma_w}
                    widthImg="7%"
                    cargando={true}
                />
            </div>
        ) : (
            <>
                <FormularioMaestroFases
                    {...props}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    firmaRefEntrevistado={firmaRef}
                    firmaRefResponsable={firmaRefResponsable}
                />

                <div
                    style={{
                        display: "flex",
                        flexDirection: accionesApiladas ? "column" : "row",
                        alignItems: accionesApiladas ? "stretch" : "center",
                        justifyContent: "flex-end",
                        padding: accionesApiladas ? "16px 12px 0" : "16px 24px 0",
                        gap: accionesApiladas ? 10 : 0,
                        width: "100%",
                        boxSizing: "border-box",
                    }}
                >
                    <Button
                        disabled={activeStep === 0 || cargando}
                        onClick={() => setActiveStep((prev) => prev - 1)}
                        variant="outlined"
                        color="primary"
                        style={accionesApiladas ? {} : { marginRight: 10 }}
                        fullWidth={accionesApiladas}
                    >
                        Atrás
                    </Button>

                    {!isLastStep ? (
                        <Button onClick={handleSiguiente} variant="contained" color="primary" fullWidth={accionesApiladas} disabled={cargando}>
                            Siguiente
                        </Button>
                    ) : (
                        <Button variant="contained" color="primary" onClick={handleEnviarConPDF} fullWidth={accionesApiladas} disabled={cargando}>
                            Enviar
                        </Button>
                    )}
                </div>
            </>
        )}
        </>
    );
    }
